import React from "react"
import PropTypes from "prop-types"
import "./heading.css"

const Heading = ({ title, styles }) => {
	return (
		<div className="heading__wrapper" style={{ ...styles }}>
			<h1 className="title">{title}</h1>
			<div className="bottom__strip" />
		</div>
	)
}

Heading.propTypes = {
	title: PropTypes.string,
	styles: PropTypes.object
}

export default Heading



// WEBPACK FOOTER //
// ./src/components/Heading.js